import { render, staticRenderFns } from "./IllegalAdSubModal.vue?vue&type=template&id=4bc74f88&scoped=true&"
import script from "./IllegalAdSubModal.vue?vue&type=script&lang=js&"
export * from "./IllegalAdSubModal.vue?vue&type=script&lang=js&"
import style0 from "./IllegalAdSubModal.vue?vue&type=style&index=0&id=4bc74f88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc74f88",
  null
  
)

export default component.exports